import { createStore } from 'store/storeCreator';

const store = createStore({});
function getStore() {
    return store;
}
export { store, getStore };
